import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { updateMainHeader } from "../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../BreadCrumbs/BreadCrumbsListner";

interface ComingSoonProps {
  title: string;
  breadCrumb: string;
  path: string;
  message?: string;
}

// Placeholder page for menu items whose backend/API is not available yet.
export const ComingSoon: React.FC<ComingSoonProps> = ({ title, breadCrumb, path, message }) => {
  useEffect(() => {
    updateMainHeader(title);
    breadCrumbsStore.updateBreadCrumbs([{ [breadCrumb]: path }]);
  }, [title, breadCrumb, path]);

  return (
    <Box sx={{ p: 4, textAlign: "center" }}>
      <Typography variant="h6">{title}</Typography>
      <Typography color="text.secondary">{message || `${title} is coming soon.`}</Typography>
    </Box>
  );
};
